<template>
  <tbody class="is-editable">
    <tr>
      <td class="c-table__cell--middle">
        <p class="u-text-ellipsis">
          <span v-if="actionLog.is_systemadmin == 1">(A)</span>
          {{ actionLog.user_id }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p class="u-text-ellipsis">
          {{ actionLog.user_name }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p class="u-text-ellipsis">
          {{ actionLog.object_id }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p class="u-text-ellipsis">
          {{ getObjectTypeById(actionLog.object_type).label }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p class="u-text-ellipsis">
          {{ getObjectStatusById(actionLog.object_status).label }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p class="u-text-ellipsis">
          {{ getFormattedCreateDate(actionLog.create_date) }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p v-if="actionLog.has_diff && (actionLog.object_status == 1 || actionLog.object_status == 2)" class="u-text-ellipsis">
          <a :href="actionLogInfo.historyUrl + '?diff_id=' + actionLog.diff_id">表示する</a>
        </p>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    actionLog: Object,
    actionLogInfo: Object,
  },
  methods: {
    getObjectTypeById(id) {
      return Object.values(this.actionLogInfo.actionObjectType).find(obj => obj.id === id);
    },
    getObjectStatusById(id) {
      return Object.values(this.actionLogInfo.actionObjectStatus).find(obj => obj.id === id);
    },
    getFormattedCreateDate(createDate) {
      return moment(createDate).format('YYYY-MM-DD HH:mm');
    }
  },
};
</script>